import {WLTypeformModal} from "../../webcomponents/typeform/typeform.component";
import {WlBrandedButton} from "../../webcomponents/brandedButton/button.component";

export function initPersonalAssistant() {
    initWhatsappOption()
    initTypeformOption()
    initLandingOption()
}

function initWhatsappOption() {
    const whatsappButton = document.querySelector<HTMLInputElement>('.js_pa-whatsapp');
    if (!whatsappButton) {
        return;
    }

    whatsappButton.addEventListener('click', () => {
        let href = whatsappButton.dataset['href'];
        window.open(href, '_blank');
    });
}

function initTypeformOption() {
    const formButton = document.querySelector<HTMLInputElement>('.js_pa-form-button');
    const modal: WLTypeformModal | null = document.querySelector<WLTypeformModal>('#js_pa-form-modal');
    if (!formButton || !modal) {
        return;
    }

    formButton.addEventListener('click', () => {
        modal.open()
    } );
}

function initLandingOption() {
    const landingButton = document.querySelector<WlBrandedButton>('.js_pa-landing-button');
    if (!landingButton) {
        return;
    }

    landingButton.addEventListener('wl-click', () => {
        window.open(landingButton.dataset['href'], '_blank');
    });
}
